import { TSalaryConverterConstants } from './SalaryConvert'

export enum EDevice {
	SMALLMOBILE = 'smallMobile',
	MOBILE = 'mobile',
	TABLET = 'tablet',
	LAPTOP = 'laptop',
	DESKTOP = 'desktop'
}

export type InsuranceOptionValue = number

export const INSURANCE_TYPE_FULL_WAGE = 1
export const INSURANCE_TYPE_OTHER = 2

export enum EInsurance {
	FULL_WAGE = 'full_wage',
	OTHER = 'other'
}

export const insuranceOptions = [
	{ id: EInsurance.FULL_WAGE, name: 'Lương chính thức' },
	{ id: EInsurance.OTHER, name: 'Khác' }
]

export const insuranceOptionsEn = [
	{ id: EInsurance.FULL_WAGE, name: 'Full wage' },
	{ id: EInsurance.OTHER, name: 'Other' }
]

export enum CurrencyType {
	VND = 'vnd',
	USD = 'usd'
}

export const currencyOptions = [
	{
		id: CurrencyType.VND,
		name: 'VND'
	},
	{
		id: CurrencyType.USD,
		name: 'USD'
	}
]

export enum SalaryType {
	GROSS = 'gross',
	NET = 'net'
}

export const salaryTypeOptions = [
	{
		id: SalaryType.GROSS,
		name: 'Gross -> Net'
	},
	{
		id: SalaryType.NET,
		name: 'Net -> Gross'
	}
]

export type RegionValue = number

export enum ERegion {
	REGION_1 = 'region-1',
	REGION_2 = 'region-2',
	REGION_3 = 'region-3',
	REGION_4 = 'region-4'
}

export const regionOptions = [
	{ id: ERegion.REGION_1, name: 'Vùng I' },
	{ id: ERegion.REGION_2, name: 'Vùng II' },
	{ id: ERegion.REGION_3, name: 'Vùng III' },
	{ id: ERegion.REGION_4, name: 'Vùng IV' }
]

export const regionOptionsEn = [
	{ id: ERegion.REGION_1, name: 'Region I' },
	{ id: ERegion.REGION_2, name: 'Region II' },
	{ id: ERegion.REGION_3, name: 'Region III' },
	{ id: ERegion.REGION_4, name: 'Region IV' }
]

export const MAX_SALARY = 9999999999

export const defaultSalaryConverterConstants: TSalaryConverterConstants = {
	baseSalary: 0,
	dependent: 0,
	employerPayHealthInsuranceChargePercentage: 0,
	employerPaySocialInsuranceChargePercentage: 0,
	employerPayUnemployedInsuranceChargePercentage: 0,
	exchangeRates: 0,
	healthInsurance: 0,
	maximumUnemployedInsurance: 0,
	personalFamilyDeduction: 0,
	regionI: 0,
	regionII: 0,
	regionIII: 0,
	regionIV: 0,
	socialAndMedicalInsurance: 0,
	socialInsurance: 0,
	unemployedInsurance: 0,
	unemploymentInsurance: 0
}
